
@if(meteringPoints.length !== 0 && numberOfMeteringPointsWithOldUc !== 0){
  <div>

    <!-- One -->
    @if(numberOfMeteringPointsWithOldUc === 1){
      <app-system-message 
        [isVisible]="true" 
        [severity]="0" 
        [icon]="'#sx-info'"
        [isDismissable]="false"
        [type]="5">
              
        <p>
          {{'core.metering-point-old-uc-linking.one.your' | translate}} 
            <a href="#" [routerLink]="['/secure/meteringpoints/' + meteringPointsWithOldUc[0].id]"
              class="sx-old-uc__mp-link" id="new-uc-one__mp-link" 
              appTrackClick sxaction="Link goto meteringpoint with old UC from start page">
              <span style="font-weight: bold;"> {{capitalize(meteringPointsWithOldUc[0].name)}}</span>
            </a>
            {{'core.metering-point-old-uc-linking.one.older-than' | translate}}  <span style="font-weight: bold;"> {{ageOfCentral}} {{'core.metering-point-old-uc-linking.one.years' | translate}}</span>{{'core.metering-point-old-uc-linking.one.upgrade' | translate}} 
        </p>
        <br>        
        <p>
          <a href="javascript:void(0)"
            (click)="goToProductDetailsPage()" 
            class="sx-old-uc__link" id="new-uc-one__link" 
            appTrackClick sxaction="Link goto product page for new UC from start page">
          {{'core.metering-point-old-uc-linking.one.link' | translate}} 
          </a>
        </p>
      </app-system-message>
    }
    @if(numberOfMeteringPointsWithOldUc > 1){
      <!-- Many -->
      <app-system-message 
        [isVisible]="true" 
        [severity]="0" 
        [icon]="'#sx-info'"
        [isDismissable]="false"
        [type]="5">
       
        <p>
          <span style="font-weight: bold;">{{totalMeteringPointsWithOldUc}}</span> {{('core.metering-point-old-uc-linking.multiple.older-than' | translate:{value: meteringPoints.length})}} <span style="font-weight: bold;"> {{oldUcMinAge}} {{'core.metering-point-old-uc-linking.multiple.years' | translate}}</span>{{'core.metering-point-old-uc-linking.multiple.upgrade' | translate}} 
        </p>
        <br>      
        <p>
          <a href="javascript:void(0)"
            (click)="goToFilteredMeteringPointList()" 
            class="sx-old-uc__link" id="new-uc-many__link" 
            appTrackClick sxaction="Link to filtered view in meteringpoint list showing only meteringpoints with old UC">
            {{'core.metering-point-old-uc-linking.multiple.link' | translate}}
          </a>
        </p>
       
      </app-system-message>
    }
  </div>
}

